var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	10423: {
		fallback: () => (() => (__webpack_require__(7552))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	17719: {
		fallback: () => (() => (__webpack_require__(88351))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.3.4",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-router",

	},
	1278: {
		fallback: () => (__webpack_require__.e(617).then(() => (() => (__webpack_require__(89617))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ecomaison-service-analytics",

	},
	26712: {
		fallback: () => (() => (__webpack_require__(45237))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.3.4",
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	30257: {
		fallback: () => (Promise.all([__webpack_require__.e(839), __webpack_require__.e(814)]).then(() => (() => (__webpack_require__(11814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@front-office/context",

	},
	36988: {
		fallback: () => (__webpack_require__.e(679).then(() => (() => (__webpack_require__(26679))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ecomaison-locale",

	},
	41541: {
		fallback: () => (() => (__webpack_require__(28485))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	58301: {
		fallback: () => (__webpack_require__.e(334).then(() => (() => (__webpack_require__(34334))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "10.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-jss",

	},
	73450: {
		fallback: () => (__webpack_require__.e(300).then(() => (() => (__webpack_require__(38300))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-final-form",

	},
	89373: {
		fallback: () => (__webpack_require__.e(375).then(() => (() => (__webpack_require__(23375))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^10.1.11",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-intl",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [10423,17719,10423,17719];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"60": [
		89373
	],
	"433": [
		26712,
		36988,
		58301,
		89373
	],
	"461": [
		10423,
		17719
	],
	"786": [
		1278,
		26712,
		30257,
		36988,
		41541,
		58301,
		73450,
		89373
	],
	"792": [
		10423,
		17719
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}